module.exports = __webpack_public_path__ + "img/fse_reg-section-loader-admin.c554af44.gif";